/**
 * Fires event, when the user scrolls
 * @param state
 */

import { ADDITIONAL_CONTENT_CONTAINER, OFFER_CARD_WRAPPER, OFFER_DISPLAY_CONTAINER } from 'Constant';

/**
 * retrieves hight of Navi
 */
export const getNaviHeight = () => {

    let naviHeight = 0;
    try {
        // Navi Height
        const naviWrapper = document.getElementsByClassName('mod-glnav')[0];
        const naviElement = naviWrapper.getElementsByClassName('main-nav')[0];
        const rectNaviElement = naviElement.getBoundingClientRect();
        naviHeight = rectNaviElement.height;
    } catch (e) {}

    return naviHeight;
};

/**
 * returns the position of viewport relative to whole ocument
 */
export const getRelativeViewportPosition = () => {
    let yScroll = 0;

    if (window.pageYOffset) {
        yScroll = window.pageYOffset;
    } else if (document.documentElement && document.documentElement.scrollTop) {
        yScroll = document.documentElement.scrollTop;
    } else if (document.body) {
        yScroll = document.body.scrollTop;
    }

    return yScroll;
};

/**
 * returns relative Position of Offer Element in viewport
 */
export const getOfferElementPosition = () => {
    let relativePosition = 0;

    const offerCardContainerElement = document.getElementById(OFFER_DISPLAY_CONTAINER);
    const offerCards = offerCardContainerElement.getElementsByClassName(OFFER_CARD_WRAPPER);
    const acContainerElement = document.getElementById(ADDITIONAL_CONTENT_CONTAINER);

    relativePosition = (0 < offerCards.length) ?
        offerCards[0].getBoundingClientRect().top :
        (acContainerElement?.hasChildNodes()) ?
            acContainerElement.children[0].getBoundingClientRect().top : 0;

    return relativePosition;
};

/**
 * adds special transition classes to div
 * @param element
 * @param targetOffset
 * @param relativeViewportPosition
 */
export const addTransitionClassesAndStyles = (element: HTMLDivElement, targetOffset: number, relativeViewportPosition: number) => {

    if (null === element || undefined === element) {
        return;
    }

    element.classList.add('in-transition');
    /**
     * as typescript tells me. that the next two attributes I use here are deprecated.
     * But I hope, I know what I'm doing, so I do it this way.
     */
    (element.style as any).WebkitTransform = 'translate(0, -' + (targetOffset - relativeViewportPosition) + 'px)';
    (element.style as any).MozTransform = 'translate(0, -' + (targetOffset - relativeViewportPosition) + 'px)';
    element.style.transform = 'translate(0, -' + (targetOffset - relativeViewportPosition) + 'px)';

};

/**
 * removes special transition classes from div
 * @param element
 */
export const removeTransitionClassesAndStyles = (element: HTMLDivElement) => {

    if (null === element || undefined === element) {
        return;
    }

    element.classList.remove('in-transition');
    element.style.cssText = '';
};

/**
 * Scrolls until offer-card is in viewport
 */
export const scrollToAccordion = () => {
    try {

        const footer = <HTMLDivElement> document.getElementsByTagName('footer')[0];
        const content = <HTMLDivElement> document.getElementById('content');

        // Relative position of document in viewport
        const relativeViewportPosition = getRelativeViewportPosition();

        // current position of Offer-Card relative to viewport
        const offerCardTop = getOfferElementPosition();

        // Navigation should be considered as well
        const naviHeight = getNaviHeight();

        // Target offset is: where are we now? where do we have to scroll to? we have to consider the navi!
        const targetOffset = relativeViewportPosition + offerCardTop - naviHeight - 10;

        addTransitionClassesAndStyles(footer, targetOffset, relativeViewportPosition);
        addTransitionClassesAndStyles(content, targetOffset, relativeViewportPosition);

        window.setTimeout(function () {
            removeTransitionClassesAndStyles(footer);
            removeTransitionClassesAndStyles(content);
            window.scrollTo(0, targetOffset);
        }, 900);

    } catch (e) {}
};
